import React from 'react';

const Loading: React.FC = () =>
{
  return (
    <div className="app-loading">
      {
        [1,2,3,4,5,6,7,8].map(item => (<div key={item} className={'item-'+item}><div className="item" /></div>))
      }
    </div>
  );
};

export default Loading;